import React, { Component } from 'react';
import { fire } from "../Firebase/firebase";

class BallThrownDog extends Component {

// Push
handleBallThrow = () => {
    let uid = fire.auth().currentUser.uid;
    fire
      .database()
      .ref("users/" + this.props.uid + "/balls_caught")
      .push({
        name: this.props.currentUser.name,
        uid: uid,
        avatar: this.props.currentUser.avatar
      })

      .catch(error => {
        console.log(error);
      });
      // Call handleDelete that has been passed down from ballsCaught.js
     this.props.handleDelete(this.props.uid);
     this.forceUpdate()
  };

	render(){

		return (
			
			<React.Fragment>
			
				<div className="profile-card" style={{paddingTop: 15}}>
					<img alt="dog profile" id="avatar-tab" className="float-left" src={this.props.avatar}/>
							<p style={{marginLeft: 75, fontSize: 30}} id="dog-name">{this.props.name}</p>						
				     </div>
				 <button onClick= {this.handleBallThrow} id="throw-back">Throw Back!</button>
				</React.Fragment>

				
			);
	
	};
}




export default BallThrownDog;